export default "__VITE_ASSET__lBhaAKCi__"